export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "scripts/app.Message.worker.da02263f59ef680fe35a.worker.js");
}
